export class UserLoginDateChange {
  static readonly type = '[UserLogin] UserLoginDateChange';

  constructor(public userLoginDate: Date = new Date()) {}
}